// extracted by mini-css-extract-plugin
export default {"divider":"DividerDefault_divider__kIZhs","divider__content":"DividerDefault_divider__content__UHbLH"};